import { errorLogger } from "@/Common/helpers/logger";
import { apiInstance } from "@/services/httpAdapter";
import { Buffer } from "buffer";

export async function urlToBase64(url: string): Promise<string | null> {
	try {
		const response = await apiInstance.get(url);
		const arrayBuffer = await response.arrayBuffer();
		return Buffer.from(arrayBuffer).toString("base64");
	} catch (error) {
		errorLogger(error as Error);
		return null;
	}
}
